import React from 'react';
import { InfoModal } from '../InfoModal/InfoModal';
import InformationCard from '../informationCard/InformationCard';

interface IConfirmationLinkedAccountModalTypes {
  onOkClick: () => void;
  isOpen?: boolean;
}

export const ConfirmationLinkedAccountModal = ({
  isOpen = true,
  onOkClick,
}: IConfirmationLinkedAccountModalTypes): React.JSX.Element => {
  return (
    <InfoModal
      isOpen={isOpen}
      onOkClick={onOkClick}
      onClose={onOkClick}
      width={300}
      title="Subscription Activated"
      buttonLabel="Continue to onboarding"
      info1="Congratulations! You’ve linked your subscription to your existing Every Mother account."
      footer={<InformationCard text="To manage your subscription, please visit the UHC Store." />}
    />
  );
};
